import { icons, type LucideProps } from 'lucide-react';

type Props = LucideProps & { name: string };

/**
 * Wrapper kring lucide-react som tar ett strangnamn istallet for component.
 * Tillater tool-set att definiera verktyg som `{ icon: 'sun', ... }` utan att
 * importera varje lucide-ikon explicit.
 */
export function Icon({ name, ...rest }: Props) {
  const LucideIcon = (icons as Record<string, React.ComponentType<LucideProps>>)[toPascalCase(name)];
  if (!LucideIcon) return null;
  return <LucideIcon {...rest} />;
}

function toPascalCase(name: string): string {
  return name
    .split('-')
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join('');
}
